import { apiRequest } from './api';

const base = '/zpanel';

export const zpanelApi = {
    listOrganizations: (params) => apiRequest(`${base}/organizations?${new URLSearchParams(params)}`),
    getOrganization: (id) => apiRequest(`${base}/organizations/${id}`),
    createOrganization: (data) => apiRequest(`${base}/organizations`, { method: 'POST', data }),
    updateOrganization: (id, data) => apiRequest(`${base}/organizations/${id}`, { method: 'PUT', data }),
    deleteOrganization: (id) => apiRequest(`${base}/organizations/${id}`, { method: 'DELETE' }),
    updateSlug: (id, slug) => apiRequest(`${base}/organizations/${id}/slug`, { method: 'PUT', data: { slug } }),
    listRestaurants: (orgId) => apiRequest(`${base}/organizations/${orgId}/restaurants`),
    createRestaurant: (orgId, data) => apiRequest(`${base}/organizations/${orgId}/restaurants`, { method: 'POST', data }),
    updateRestaurant: (orgId, restaurantId, data) => apiRequest(`${base}/organizations/${orgId}/restaurants/${restaurantId}`, { method: 'PUT', data }),
    deleteRestaurant: (orgId, restaurantId) => apiRequest(`${base}/organizations/${orgId}/restaurants/${restaurantId}`, { method: 'DELETE' }),
    addUser: (orgId, data) => apiRequest(`${base}/organizations/${orgId}/users`, { method: 'POST', data }),
    updateUser: (orgId, userId, data) => apiRequest(`${base}/organizations/${orgId}/users/${userId}`, { method: 'PUT', data }),
    removeUser: (orgId, userId) => apiRequest(`${base}/organizations/${orgId}/users/${userId}`, { method: 'DELETE' }),
    listSubscriptionPlans: () => apiRequest(`${base}/subscription-plans`),
    createSubscriptionPlan: (data) => apiRequest(`${base}/subscription-plans`, { method: 'POST', data }),
    updateSubscriptionPlan: (planId, data) => apiRequest(`${base}/subscription-plans/${planId}`, { method: 'PUT', data }),
    deleteSubscriptionPlan: (planId) => apiRequest(`${base}/subscription-plans/${planId}`, { method: 'DELETE' }),
    refreshSlugsHtaccess: () => apiRequest(`${base}/slugs/refresh-htaccess`, { method: 'POST' })
};
